import React, { Component } from 'react';
import axios from 'axios';
import formaat from 'string-template'
import $ from 'jquery'

import Spinner from '../Spinner';

import './style.css';

let timeout;

let initialState = {
    value: "",
    outObject: {
        id: null,
        value: null
    },
    items: null,
    showItems: false,
    fetching: false,
    optional: false,
    clearAfterChoice:false,
    activeIndex:null,
    mapping:{
        id:"id",
        value:"value",
        shownValue:null,
        dataFieldName:null
    }
}

class SearchInput extends Component {
    constructor(props) {
        super(props);
        this.state= {
            ...initialState,
            ...props
        }

        this.state.items = props.items? this.funcMapping(props.items): []
        this.searchItems ={}
        
    }
    componentDidMount() {
        document.addEventListener('mousedown',(e)=> this.handleClickOutside(e));

    }
    componentWillReceiveProps(props) {
        if (JSON.stringify(props) !== JSON.stringify(this.props)) {
            this.funcPropsToState(props);
        }
      
    }
    componentDidUpdate(){
        // задать высоту блока с элементами
        if(this.items){
            let innerHeight = window.innerHeight;
            let offset = $(this.items).offset();
            let maxHeight = innerHeight - offset.top +$(window).scrollTop()
            $(this.items).css("max-height",maxHeight)
        }

    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', (e) => this.handleClickOutside(e));
    }
    handleChangeSearch(value) {
        clearTimeout(timeout);
        let th = this;
        this.setState({
            value: value
        },
            () => {
                timeout = setTimeout(() => {
                        th.apiGetItems();
                    if (th.state.optional) { // если необязательное поле, т.е. не обязательно возвращать объект из апи. можно заполнить в ручную
                        th.setState({
                            outObject: {
                                ...th.state.outObject,
                                value: value
                            }
                        },() => {
                            th.funcThrowObject();
                        });
                    }
                },
                400);
            }
        );
    }
    handleKeyDown(e) {
        let key = e.key;
        if (this.state.items != null && this.state.items.length > 0) {
            console.log(key);
            let activeIndex = this.state.activeIndex;
            let items = this.state.items;
            switch (key) {
                case "ArrowDown":
                    e.preventDefault();
                    if (activeIndex == null) {
                        activeIndex = 0;
                    } else {
                        activeIndex += 1;
                    }
                    break;
                case "ArrowUp":
                    e.preventDefault();
                    if (activeIndex == null) {
                        activeIndex = items.length - 1;
                    } else {
                        activeIndex -= 1;
                    }
                    break;
                case "Enter":
                    e.preventDefault();
                    if (activeIndex == null) {
                        activeIndex = 0;
                    }
                    this.handleItemClick(activeIndex);
                    activeIndex = null;
                    break;
                case "Backspace":
                    activeIndex = null;
                    break;
                default:
                    activeIndex = null;
                    break;
            }

            if (activeIndex > items.length - 1) {
                activeIndex = items.length - 1;
            }else if (activeIndex < 0) {
                activeIndex = 0;
            }

            if(activeIndex != null){
                if(!this.state.showItems){
                    this.setState({
                        showItems:true
                    },()=>{
                        this.funcScrollTo(activeIndex)
                    })

                }

            }


            this.setState({
                activeIndex: activeIndex
            });

        }
       
    }
    handleItemClick(itemIndex) {
        let item = this.state.items[itemIndex];
        let isChange = item.id !== this.state.outObject.id;


        let newItems =this.state.items
        if( this.state.clearAfterChoice){
            if(this.props.items){
                newItems =  this.funcMapping(this.props.items)
            }
        }
        if (isChange) {



            this.setState({
                    outObject: {
                        id: item.id,
                        value:item.value,
                        shownValue:item.shownValue
                    },
                    value:this.state.clearAfterChoice?"": item.shownValue,
                    items:newItems
                },
                () => {
                    this.funcThrowObject();
                });
        }else if(this.state.clearAfterChoice){
            this.setState({
                items:newItems
            })
        }

        this.setState({
            showItems: false,
            value: this.state.clearAfterChoice?"": item.shownValue,
            activeIndex:itemIndex
        });
    }
    handleInputClick() {
        this.setState({
            showItems: true
        });
    }
    handleClickOutside(e) {
        if (this.wrapp && !this.wrapp.contains(e.target)) {
            this.setState({
                showItems: false
            });
        }
    }

    funcPropsToState(props) {
       
        this.setState({
            ...this.state,
            ...props,
            items: props.items? this.funcMapping(props.items): []

        });

        if (props.value === "" && props.items === undefined) {
            this.setState({
                items: null
            });
        }


    }
    funcThrowObject() {
        if (this.props.onObjectChange) {
            this.props.onObjectChange(this.state.outObject);
        }
    }
    funcMapping(resData){  //Mapping
        let dataFieldName = this.state.mapping.dataFieldName;
        let id = this.state.mapping.id;
        let value = this.state.mapping.value;
        let shownValue = this.state.mapping.shownValue;

        let data = dataFieldName != null ?
            (()=>{
                let nameArr = dataFieldName.split("."); // возможен формат "content.data"
                let result = resData;
                nameArr.forEach((item)=>{
                    result = result[item]
                });
                return result;
            })()
            :
            resData

        let result = [];
        data.forEach((item,index)=>{
            let itemValue = formaat(value,item);
            result.push({
                id:id ? item[id] : index,
                value: itemValue,
                shownValue: shownValue != null ?  formaat(shownValue,item): itemValue
            })
        })

        return result;
    }

    funcScrollTo(index){
        let domElement = $(this.searchItems[index]);
        let domiItems = $(this.items);

        console.log("height",domElement.height())
        console.log("spaceToTop",domElement.offset())

        let spaceToTopElement = domElement.offset().top
        let elementHeight = domElement.outerHeight()

        let spaceToTopItems = domiItems.offset().top
        let itemsHeight = domiItems.outerHeight()

        if(spaceToTopElement+elementHeight > spaceToTopItems+itemsHeight){
            //scrollDown
            domiItems.scrollTop(domiItems.scrollTop()+(elementHeight))
        }else  if(spaceToTopElement < spaceToTopItems){
            //scrollUp
            domiItems.scrollTop(domiItems.scrollTop()-(elementHeight))
        }


    }

    apiGetItems() {
       
        if (this.state.apiUrl /*&& !this.state.fetching*/ && this.state.value.length > 0) {
            this.setState({
                fetching: true,
                outObject: initialState.outObject,
                activeIndex:initialState.activeIndex
                },
                () => {
                   // this.funcThrowObject();

                    axios.get(this.state.apiUrl + this.state.value)
                        .then((response) => {
                            console.log("response", response);
                            this.setState({
                                items: this.funcMapping(response.data),
                                fetching: false,
                                showItems:true
                            });

                        })
                        .catch((error) => {
                            console.log("error", error);
                            console.log("response", error.response);
                            this.setState({
                                items: initialState.items,
                                fetching: false,
                            });
                        });
                });

        } else {
            if (this.props.items) {
                let items = this.funcMapping(this.props.items);
                let itemsForChoice = [];
                items.forEach((item) => {
                    if (item.value.toLowerCase().indexOf(this.state.value.toLowerCase()) !== -1) {
                        itemsForChoice.push(item);
                    }
                });
                this.setState({
                    items: itemsForChoice,
                    showItems: itemsForChoice.length > 0
                });

            } else {
                this.setState({
                    items: null,
                    showItems: false
                });
            }
           
        }
    }
    render() {

        let isShowItems = this.state.items != null && this.state.items.length > 0 && this.state.showItems;
        let wrapperClass = "search-input " + this.props.className ;
        if (isShowItems) {
            wrapperClass += " items-show";
        }
        if (!isShowItems && this.props.items) {
            wrapperClass += " select";
        }


        return (
            <div className={wrapperClass} ref={(wrapp) => this.wrapp = wrapp}>
              
                {
                    this.state.fetching ?
                        <Spinner styles={{ backgroundColor: "#37474F" }} className="absolute-right" />
                        :null
                }
                <input
                    className="form-control"
                    value={this.state.value}
                    placeholder={this.props.placeholder}
                    onChange={(e) => this.handleChangeSearch(e.target.value)}
                    onKeyDown={(e) => this.handleKeyDown(e)}
                    onClick={() => this.handleInputClick()}
                />

                {
                    isShowItems ?
                        <div className="search-items"
                             ref={(elem)=>this.items = elem}
                        >
                            {
                                this.state.items.map((elem, index) => {
                                    let className = "item";
                                    if (this.state.activeIndex === index) {
                                        className += " active";
                                    }
                                    return (
                                        <div
                                            ref={(ref)=>{this.searchItems[index] = ref}}
                                            className={className}
                                            key={index}
                                            onClick={() => this.handleItemClick(index)}
                                            dangerouslySetInnerHTML={{__html:elem.value}}
                                        >
                                        </div>
                                        );
                                })
                            }
                        </div>
                    : null
                }

              
            </div>
            );
    }
}

export default SearchInput;


// WEBPACK FOOTER //
// ./src/components/Shared/SearchInput/index.jsx